module.exports = __webpack_public_path__ + "assets/img/138c-sb.svg";